export default __webpack_public_path__ + "static/media/ic-lightbulb.42ae192a.svg";